define('views/items/footerLinksView',[
    'views/base/baseItemView',
    'hbs!templates/items/footerLinks'
], function (BaseItemView, FooterLinksTmpl) {
    'use strict';
    return BaseItemView.extend({
        template: FooterLinksTmpl,

        initialize: function () {
        },

        onRender: function () {
        }
    });
});
